import { IUser } from 'core/auth/AuthDataModel';
import util from './util';

const storage: Storage = window.sessionStorage;
const storeObject = (key, object) => {
    storage.setItem(key, JSON.stringify(object));
};
const retrieveObject = (key) => {
    const item = storage.getItem(key);
    return util.estNul(item) ? null : JSON.parse(item);
};

const AUTH_TOKEN = 'auth_token';
const AUTH_USER = 'auth_user';
const AUTH_ROLE = 'auth_role';
const AUTH_DID = 'auth_did';

const SessionStorage = {
    clear: (): void => {
        storage.clear();
    },
    getUser: (): IUser => {
        return retrieveObject(AUTH_USER);
    },
    setUser: (user: IUser) => {
        storeObject(AUTH_USER, user);
        storeObject(AUTH_ROLE, user?.role);
        storeObject(AUTH_TOKEN, user?.token);
        storeObject(AUTH_DID, user?.did);
    },
    getToken: (): string => {
        return retrieveObject(AUTH_TOKEN);
    },
    getDid: (): string => {
        return retrieveObject(AUTH_DID);
    },
    getRole: (): string => {
        return retrieveObject(AUTH_ROLE);
    },
    setRole: (role: string) => {
        storeObject(AUTH_ROLE, role);
    },
};

export default SessionStorage;
